/**
 * Applied by the nuqs adapter to every URL it writes: keys in a stable, sorted order, so the same state always
 * produces the same URL (shareable filter links, one cache key per list page).
 */
export function processURLSearchParams(search: URLSearchParams) {
  search.sort()
  return search
}
